<template>
  <footer class="portal-footer">
    <div class="page-shell portal-footer__row">
      <div>
        <div class="portal-footer__title">SkyVision / AeroCommander</div>
        <div class="small">Портал видеотрансляций и мониторинга</div>
      </div>
      <div class="portal-footer__contact">
        <span class="small">Контакты</span>
        <a :href="emailLink">uas.ts@crs.kz</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      emailLink: 'mailto:uas.ts@crs.kz'
    };
  }
};
</script>

<style scoped>
.portal-footer {
  margin-top: 32px;
  padding: 16px 0 20px;
  border-top: 1px solid #d7e3ef;
  background: #f8fbff;
}

.portal-footer__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: var(--app-text-muted);
}

.portal-footer__title {
  color: var(--app-text);
  font-weight: 700;
  margin-bottom: 4px;
}

.portal-footer__contact {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.portal-footer__contact a {
  color: var(--app-accent);
  text-decoration: none;
}

@media (max-width: 768px) {
  .portal-footer__row,
  .portal-footer__contact {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>